import injectSheet from 'react-jss'
import AutocompleteSuggestions from './AutocompleteSuggestions'
import styles from './AutocompleteSuggestions.styles'

export default injectSheet(styles)(AutocompleteSuggestions)
